import React from "react";
import {type} from "@codeArt/utils/common";
import {HelpLink} from "./button/link";

export function parseHelp(arg){
  //解析帮助文档的参数
  if (type(arg) === "string") {
    if (arg.startsWith("http://") || arg.startsWith("https://")) {
      return {url: arg};
    }
    return {message: arg};
  }
  return arg || {};
}

export function getHelpIcon(help, linkProps){
  let {url, message} = parseHelp(help);
  linkProps = linkProps || {};
  let {className, textClassName} = linkProps;
  if (url || message)
    return (
      <HelpLink
        size="md"
        tip={message}
        href={url}
        {...linkProps}
        className={`${url ? "" : "c-text-grey"} ${className || ""}`}
        textClassName={`${url ? "" : "c-text-grey"} ${textClassName || ""}`}
      />
    );
}
